import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useAppDispatch } from "../../../../store";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducer/index";
import * as styles from "../../../../styles/WholedataPage";
import {
  LoadFarm,
  LoadDiaryList,
  TargetDiaryAct,
  GetWeather,
  API_BASE_URL,
} from "../../../../reduxaction/post";
import axios from "axios";
import { off } from "process";
import { Loadme } from "../../../../reduxaction/user";
import jwtDecode, { JwtPayload } from "jwt-decode";
import userSlice from "../../../../reducer/user";
import InsectLifeCycle from "../component/InsectLifeCycle";
import InsectName from "../component/InsectName";
import InsectImage from "../component/InsectImage";
import Environment from "./component/Environment";
import PostDiaryForm from "./component/PostDiaryForm";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import Modal from "../../../../components/Modal";
import {
  DiaryClasstype,
  TargetDiarytype,
  TotaldataType,
  manageBoxType,
} from "../../../../reducer/postpayloadtypes";
import styled, { createGlobalStyle } from "styled-components/macro";
import BeforeData from "../DiaryDetail/component/BeforeData";

dayjs.locale("ko");

const SearchBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 40px;
  margin: 0 auto;
  margin-top: 15px;
`;

const SearchInput = styled.input`
  margin-right: 10px;
  flex-grow: 1;
  border: 3px solid #73972c;
	border-radius: 5px;
	line-height: 30px;
	padding: 0 10px;
  flex-grow: 1;
`;

const SearchButton = styled.button`
  width: 80px;
  height: 36px;
  border: 3px solid #73972c;
  cursor: pointer;
	border-radius: 5px;
  background-color: #ffffff; /* White */
  color: black;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  &:hover {
    background-color: #f2f2f2;
    color: black;
  }
`;

const Styledtable = styled.table`
  width: 650px; // 테이블의 너비를 키웁니다.
  border-collapse: collapse;
  background-color: #ffffff; // 배경색을 더 밝게 변경합니다.
  border: 1px solid #eee; // 테두리 색을 더 밝게 변경합니다.
  text-align: center;
  font-family: 'Arial, sans-serif';
`;

const StyledTh = styled.th`
  width: 80px; // 셀의 너비를 키웁니다.
  font-size: 12px; // 폰트 크기를 키웁니다.
  border: 1px solid #eee; // 테두리 색을 더 밝게 변경합니다.
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5; // 배경색을 더 밝게 변경합니다.
`;

const StyledTd = styled.td`
  text-align: center;
  border: 1px solid #eee; // 테두리 색을 더 밝게 변경합니다.
  font-size: 11px; // 폰트 크기를 키웁니다.
`;


export interface JwtPayloads {
  preferred_username: string;
}


const PostDiaryPage = () => {
  const navigate = useNavigate();
  // 새로고침 막기 변수
  const preventClose = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = ""; // chrome에서는 설정이 필요해서 넣은 코드
  };

  // 브라우저에 렌더링 시 한 번만 실행하는 코드
  useEffect(() => {
    (() => {
      window.addEventListener("beforeunload", preventClose);
    })();

    return () => {
      window.removeEventListener("beforeunload", preventClose);
    };
  }, []);

  const dispatch = useAppDispatch();

  const { TargetDiary, Farms, Targetfarms, TargetInsectContainer } =
    useSelector((state: RootState) => state.post);
  const { me, Routerpath } = useSelector((state: RootState) => state.user);
  useEffect(() => {
    const Loadmefunc = async () => {
      // let userId = await EncryptedStorage.getItem('userId');
      let accessToken = await localStorage.getItem("accessToken");
      let refreshToken = await localStorage.getItem("refreshToken");
      if (accessToken) {
        const decoded = jwtDecode<JwtPayloads>(accessToken);
        let userId = decoded.preferred_username;

        let data = {
          accessToken: accessToken,
          refreshToken: refreshToken,
          userId: userId,
        };

        dispatch(Loadme(data));
      }
    };

    Loadmefunc();
  }, [dispatch]);

  const mycontainer = Targetfarms?.children.filter(
    (v) => v.name === TargetInsectContainer
  );

  useEffect(() => {
    if (!Targetfarms) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    dispatch(LoadFarm());
  }, []);
  // 중복 submit 방지
  let [postsubmit, setPostsubmit] = useState<boolean>(true);
  //placeId 설정
  let placefarm = Targetfarms?.placeId; //농장 place
  let placecon; // 컨테이너 place

  Targetfarms?.children.map((item, idx) => {
    if (item.name === TargetInsectContainer) {
      placecon = item.placeId;
    }
  });
  const [postmodal, setPostmodal] = useState<boolean>(false);
  let [occurImage, setOccurImage] = useState<any>([]); // 질병관리 이미지1
  let [deathImage, setDeathImage] = useState<any>([]); // 질병관리 이미지2
  let [inputitem, setInputitem] = useState<any>([]); // 작업별 input 아이템
  let [diaryClassId, setDiaryClassId] = useState<Number>(); // diaryClassId
  let [modal, setModal] = useState<number>(0);

  // 생육조사 diaryClassId 76
  let [placeId, setPlaceIds] = useState<any>([]); //placeId
  let [boxName, setBoxName] = useState<any>([]);

  const [boxlist, setBoxlists] = useState<{ boxName: string; manageBoxId: number; instar: string; }[]>([]);
  const [orgboxlist, setOrgBoxList] = useState(boxlist);

  const [checkItems, setCheckItems] = useState<number[]>([]);
  const [latestCheckItems, setLatestCheckItems] = useState<number[]>([]);
  let checkItemCnt = 0;

  // 검색어
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermYn, setSearchTermYn] = useState<boolean>(false);

  // 일지 List 저장
  const [diaryList, setDiaryList] = useState<any>([]);
  const [beforeDiaryList, setBeforeDiaryList] = useState<any>([]);
  const [filteredDiaryList, setFilteredDiaryList] = useState<any>([]);

  const [checkedDiaryId, setDiaryId] = useState<number>(0);
  const [productCode, setProductCode] = useState<string>("");
  const [diaryType, setDiarytype] = useState<string>("");
  const [selectedBoxPlaceId, setSelectedBoxPlaceId] = useState<any>(0);
  const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>({});

	const [isArrow, setIsArrow] = useState<string>("");
  const [id1, setId1] = useState<string>("");
  const [id2, setId2] = useState<string>("");
  const [id3, setId3] = useState<string>("");
	const [id4, setId4] = useState<string>("");
	const [id5, setId5] = useState<string>("");
	
  const prevInsectkindRef = useRef<string>("");
  let [date, setDate] = useState(); // 작업 시간 등록
  let [time, setTime] = useState(); // 작업 날짜 등록
  let [memo, setMemo] = useState(); // 메모 등록
  let [age, setAge] = useState(); // 곤충 나이
  let [instartid, setInstartid] = useState<any>(); //곤충령기 DiaryClassId
  let [productid, setProductid] = useState<any>(); // 사육곤충 DiaryClassId
  let [startFarmDateId, setStartFarmDateId] = useState<any>(); // 사육시작일 DiaryClassId
  let [expFarmDate, setExpFarmDate] = useState<any>(); // 사육종료일 DiaryClassId
  let [endFarmDate, setEndFarmDate] = useState<any>(); // 출하일 DiaryClassId
  let [cleaningid, setCleaningid] = useState<any>([]); // 청소소독 check 클릭 안됬을떄 기본DiaryClassId
  //등록시간
  let [startdate, setStarDate] = useState<any>({
    time: "", // 시간
    startday: "", // 날짜
  });
  //DiaryClassId
  // 생육조사
  let [growing, setGrowing] = useState<any>({
    wormWeight: { diaryItemId: null, value: null },
    wormLength: { diaryItemId: null, value: null },
    wormHeadSize: { diaryItemId: null, value: null },
    // instart: { "diaryItemId": instartid, "value": age }
  });
  // console.log("growing:", growing);
  //사료교체
  let [feedchange, setFeedchange] = useState({
    soilWeight: { diaryItemId: null, value: null },
    // totalFeedWeight: { diaryItemId: null, value: null },
    // totalSoilWeight: { diaryItemId: null, value: null },
  });
  //청소소독
  let [cleaning, setCleaning] = useState<any>({
    cleanDate: {
      diaryItemId: 0,
      value: false,
    },
  });

  const [insectkind, setInsectkind] = useState<string>("");

  useEffect(() => {
    const selectedInsectCode = location.state.selectedInsectKey.name;
    // console.log("selectedInsectCode :: ", selectedInsectCode);
    setInsectkind(selectedInsectCode);

    // Targetfarms?.children.map((item, idx) => {
    //   if (item.name === TargetInsectContainer) {
    //     targetinsect = item.productCode; // 곤충종류
    //     setInsectkind(targetinsect);
    //   }
		// });
		
		if (location.search || (location.state != null && location.state.isArrow)) { 
			
			let isArrow = location.search ? location.search.split("&")[0].split("=")[1]: location.state.isArrow;
			let id1 = location.search ? location.search.split("&")[1].split("=")[1]: location.state.id1;
			let id2 = location.search ? location.search.split("&")[2].split("=")[1]: location.state.id2;
			let id3 = location.search ? location.search.split("&")[3].split("=")[1]: location.state.id3;
			let id4 = location.search ? location.search.split("&")[4].split("=")[1]: location.state.id4;
			let id5 = location.search ? location.search.split("&")[5].split("=")[1]: location.state.id5;

			
			if (isArrow !== "") setIsArrow(isArrow);
			if (id1 !== "") setId1(id1);
			if (id2 !== "") setId2(id2);
			if (id3 !== "") setId3(id3);
			if (id4 !== "") setId4(id4);
			if (id5 !== "") setId4(id5);
		}
  }, []);

  ////////// 인풋 아이템 불러오기

  const location = useLocation();

  useEffect(() => {
    console.log("insectkind", insectkind);
    if (insectkind) {
      axios.get(
        `${API_BASE_URL}/ifactory/api/diaryCode/classitem?productCode=${insectkind}`
      )
        .then((res) => {
          // console.log("res:", res);
          setInputitem(res.data);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [placeId, insectkind]);

  //청소소독 Itemid 기본값 설정
  useEffect(() => {
    const cleandirayitemid: DiaryClasstype = inputitem?.diaryClasses?.find(
      (v: DiaryClasstype) => v.diaryType === "CLEAN"
    );

    const diaryitemid = cleandirayitemid?.diaryItems.find(
      (v) => v.name === "cleanDate"
    );

    setCleaning({
      ...cleaning,
      cleanDate: {
        diaryItemId: diaryitemid?.diaryItemId,
        value: false,
      },
    });
  }, [inputitem]);

  //급이
  let [feedGive, setFeedGive] = useState({
    feedName: { diaryItemId: null, value: null },
    feedWeight: { diaryItemId: null, value: null },
    boxFeedWeight: { diaryItemId: null, value: null },
    feedTime: { diaryItemId: null, value: null },
    boxWeight: { diaryItemId: null, value: null },
  });
  //질병
  let [disease, setDisease] = useState({
    diseaseCount: { diaryItemId: null, value: null },
    wormDeadWeight: { diaryItemId: null, value: null },
  });
  const InputHandler = (e: any) => {
    setStarDate({ ...startdate, [e.target.name]: e.target.value });
  };
  const SelectHandler = (e: any) => {
    setAge(e.target.value);
  };
  const AreaHandler = (e: any) => {
    setMemo(e.target.value);
  };
  let targetinsect: any; // 현재 작성중인 다이어리 곤충이름
  // let boxlist: any = [];  
  let targetcontainer: any; // 현재 컨테이너 데이터

  type Box = {
    name: any;
    placeId: any;
    idx: any;
    // productCode: any;
  };
  const [selectedBoxes, setSelectedBoxes] = useState<Box[]>([]);

  // console.log("Targetfarms?.children", Targetfarms);

  // Targetfarms?.children.map((Obj, idx) => {
  //   if (TargetInsectContainer === Obj.name) {
  //     targetinsect = Obj.productCode;
  //   }
  //   if (Obj.name === TargetInsectContainer) {
  //     targetcontainer = Obj;
  //     Obj.children.map((item, idx) => {
  //       boxlist.push({
  //         name: item.name,
  //         boxId: item.placeId,
  //         productCode: item.productCode,
  //         instar: item.instar,
  //       });
  //     });
  //   }
  // });

  const formatBeforeDate = (date: string) => {
    return dayjs(date).format("YYYY년 MM월 DD일 dddd HH시 mm분");
  };

  // 박스선택하기 상자 조회
  useEffect(() => {
    const searchBox = async () => {

      const selectedPlaceId = location.state.selectedPlaceId;
			
      const selectedInsectCode = location.state.selectedInsectKey.name;

      console.log("selectedInsectCode", selectedInsectCode);
      console.log("selectedPlaceId", selectedPlaceId);

      try {
        const response = await axios.get(`/ifactory/api/place/insect/boxes?placeId=${selectedPlaceId}&type=CONTAINER`);
        console.log("상자 조회 response :: ", convertToArray(response.data));
        const result = response.data;

        console.log(result);
        console.log(insectkind);

        const insectData = result[selectedInsectCode];

        setBoxlists(insectData);
        setOrgBoxList(insectData);

        console.log("insectData 22 ", insectData);

      } catch (error) {
        // 오류 처리
      }
    };

    // 페이지 로딩 시에 실행
    searchBox();
  }, []);

  // 생육단계 조회
  useEffect(() => {
    const searchGrowth = async () => {
      const selectedInsectCode = location.state.selectedInsectKey.name;

      try {
        const response = await axios.get(`/ifactory/api/lifecycle?productCode=${selectedInsectCode}`);
        console.log("생육단계 response", response.data);
        setInsectinstar(response.data);
      } catch (error) {
        console.log("error:", error);
      }
    };

    // 페이지 로딩 시에 실행
    searchGrowth();
  }, []);

  const convertToArray = (data: any[]) => {
    return Object.entries(data).map(([key, value]) => {
      return value.map((item: any) => ({
        name: item.name,
        placeId: item.placeId,
        instar: item.instar,
      }));
    }).flat();
  };

  // 체크박스 클릭
  const handleSingleCheck = (checked: boolean, id: number, e: React.ChangeEvent<HTMLInputElement>) => {

    console.log("2). checkItems 확인 :: ", checkItems);

    console.log("2-1). checkItems 확인 :: ", checkItems);

    // 1개 체크를 위한 카운팅 체크용 변ㄴ수
    /*et countingCheck;
    if (checked) {
      countingCheck = [...checkItems, id];
    } else {
      countingCheck = checkItems.filter(el => el !== id);
    }
    setLatestCheckItems(countingCheck);

    console.log("2-2). countingCheck 확인 :: ", countingCheck);

    let updatedItems;
    if (countingCheck.length > 1) {
      alert('이미 다른 항목이 체크되어 있습니다. 하나만 선택해주세요.');
      e.preventDefault(); 
      updatedItems = [...checkItems];
      
    } else {
      if (checked) {
        updatedItems = [...checkItems, id];
      } else {
        updatedItems = checkItems.filter(el => el !== id);
      }

      setCheckItems(updatedItems);

    }
    */
    let updatedItems;
    if (checked) {
      updatedItems = [...checkItems, id];
    } else {
      updatedItems = checkItems.filter(el => el !== id);
    }

    setCheckItems(updatedItems);

    console.log("2-3). updatedItems 확인 :: ", updatedItems);

  };

  useEffect(() => {

    // setLatestCheckItems(checkItems);

    console.log("3). useEffect 실행 checkItems.length :: ", checkItems.length);
    checkItemCnt = checkItems.length;
    console.log("4). checkItemCnt", checkItemCnt);


    if (checkItems.length === 1) {
      console.log('체크박스 상태가 변경', checkItems);
      setDiaryId(checkItems[0]);

      console.log("checkedDiaryId", checkedDiaryId);
    }

  }, [checkItems, checkedDiaryId]);

  const [insectinstar, setInsectinstar] = useState<
    {
      lifeCycle: string;
      productCode: string;
      seq: Number;
    }[]
  >();

  useEffect(() => {
    const getlifecycle = async () => {
      try {
        const response = await axios.get(
          `ifactory/api/diaryCode/classitem?productCode=${productCode}&diaryType=${diaryType}`
        );

        // setInsectinstar(response.data.lifeCycleCode);
        // setAge(response.data[0].lifeCycle);

        //곤충 령기 아이템
      } catch (error) {
        console.error("error:", error);
      }
    };
    if (insectkind) {
      getlifecycle();
    }
  }, [placeId, insectkind]);

  let [OpenWork, setOpenWork] = useState(true); // rotate 컨트롤러 (해당 컴포넌트 접었다 열었다 하는거)
  let [boxstyle, setboxstyle] = useState<any>([]); // 상자 Ui변경

  const [imageSrc, setImageSrc] = useState<any>([]); // 이미지 미리보기
  const [ImageTotal, setImageTotal] = useState(0); // 등록 이미지 카운트
  const [uploadImage, setUploadImage] = useState<any>([]); // 업로드할 이미지
  const [selectwork, setSelectwork] = useState(0); // 어떤 작업의 일지를 선택했는지
  const [mount, setMount] = useState(false);

  const [envData, setEnvData] = useState({ name: null, placeId: null, idx: null });

  const cleanDatecovert = (data: any) => {
    if (
      data.diaryItem.name === "feedTime" ||
      data.diaryItem.name === "lastfeedTime"
    ) {
      if (data.value === "1") {
        return "O";
      } else if (data.value === "0") {
        return "X";
      }
    } else {
      return data.value;
    }
  };

  useEffect(() => {
    setImageTotal(imageSrc.length);
  }, [imageSrc]);

  //diaryClassId 설정
  const WorkSelector = (diaryClassId: any, seq: any) => {
    setSelectwork(seq);
    setDiaryClassId(diaryClassId);
  };
  useEffect(() => {
    //해당 카테고리 diaryItem 셋팅
    inputitem?.diaryClasses?.map((Obj: any) => {
      if (diaryClassId === Obj.diaryClassId) {
        Obj?.diaryItems.map((diaryItem: any) => {
          switch (diaryItem.name) {
            case "instar": // 곤충령기
              setInstartid(diaryItem.diaryItemId);
              break;
            case "productCode": // 곤충
              setProductid(diaryItem.diaryItemId);
              break;
            case "startFarmDate": // 시작일
              setStartFarmDateId(diaryItem.diaryItemId);
              break;
            case "expFarmDate": // 출하예정일
              setExpFarmDate(diaryItem.diaryItemId);
              break;
            case "endFarmDate": // 출하일
              setEndFarmDate(diaryItem.diaryItemId);
              break;
          }
        });
      }
    });
  }, [diaryClassId]);

  useEffect(() => {
    if (prevInsectkindRef.current !== insectkind) {
      setMount(true);

      if (mount) {
        confirmAlert({
          title:
            "해당 박스는 곤충이 달라 따로따로 작성해야 합니다. 일지를 다시 작성해주세요",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }
      setGrowing([]);
      setFeedchange({
        soilWeight: { diaryItemId: null, value: null },
      });
      setCleaning([]);
      setFeedGive({
        feedName: { diaryItemId: null, value: null },
        feedWeight: { diaryItemId: null, value: null },
        boxFeedWeight: { diaryItemId: null, value: null },
        feedTime: { diaryItemId: null, value: null },
        boxWeight: { diaryItemId: null, value: null },
      });
      setDisease({
        diseaseCount: { diaryItemId: null, value: null },
        wormDeadWeight: { diaryItemId: null, value: null },
      });
      setPlaceIds([]);
      setSelectedBoxes([]);
      setSelectwork(0);
      setDiaryClassId(0);
      prevInsectkindRef.current = insectkind;
    }
  }, [insectkind, mount]);

  // 이전 데이터 팝업에 전달할 데이터
  const handleBeforeDiaryList = (beforeDiaryList: any[], diaryId: any) => {
    let filteredData = beforeDiaryList.filter((el: any) => el.diaryId === diaryId);

    console.log("diaryId 값 체크:: ", diaryId);
    console.log("filteredData 값 체크:: ", filteredData);

    setFilteredDiaryList(filteredData);
  }

  const handleboxBtn = async (
    name: any,
    placeId: any,
    idx: any,
    instar: any,
  ) => {
    console.log(name, placeId, idx, instar);
    // setInsectkind(productCode);
    // setPlaceIds([...placeId, placeId]);

    setEnvData({ name, placeId, idx });
    setSelectedBoxes([{ name, placeId, idx }]);
    setPlaceIds([placeId]);
    setAge(instar);
    // setDiaryList([]);
    // setCheckItems([]);

    setSelectedBoxPlaceId(selectedBoxPlaceId);

    console.log("placeId :: ", placeId);
    console.log("선택된 placeId :: ", selectedBoxPlaceId);

    try {
      const response = await axios.get('ifactory/api/diary/day/' + placeId);
      console.log(response.data);

      setDiaryList(response.data);
      setBeforeDiaryList(response.data);
      setEnvData({ name, placeId, idx });
      // setBeforeDiaryList(Array(4).fill([...response.data]).flat());
			// console.log("beforeDiaryList 리스느 내용 확인용 :: ", response.data);
    } catch (error: any) {
      console.error(error.response.data.message);
    }

    // let alreayid = placeId.includes(placeId);

    // if (alreayid) {
    //   let filterdata = placeId.filter((v: any) => v !== placeId);
    //   setPlaceIds([...filterdata]);

    //   setSelectedBoxes(filterdata);

    //   let filteredBoxes = selectedBoxes.filter((box: any) => box.placeId !== placeId);
    //   setSelectedBoxes(filteredBoxes);
    // } else {
    //   const newBox = { name, placeId, idx };
    //   setSelectedBoxes([...selectedBoxes, newBox]);
    // }

  };
  useEffect(() => {
    // console.log("diaryList", diaryList);
  }, [diaryList, beforeDiaryList, placeId]);

  useEffect(() => {
    console.log("선택된 placeId :: ", selectedBoxPlaceId);
  }, [selectedBoxPlaceId]);

  useEffect(() => {
    console.log(selectedBoxes);
  }, [selectedBoxes]);

  // 검색 버튼 클릭
  const handleClick = (event: any) => {
//    setSearchTerm(event.target.value);
    if (searchTerm.trim() !== '') {
      const filtered = boxlist.filter((item: any) => {
        console.log("searchTerm", searchTerm);
        console.log("item.name", item.name);
        return item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
      setBoxlists(filtered);
    } else {
      setBoxlists(orgboxlist);
    }
  };

  // 검색어 입력 시 실행되는 함수
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(event.target.value);
		setSearchTermYn(false);

    if (event.target.value === '' && searchTermYn) {
      setBoxlists(orgboxlist);
    }
  };

  // Enter 누르면 검색 이벤트
  const handleKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      // Enter 키를 누르면 검색 이벤트를 실행합니다.
      setSearchTerm(event.target.value);

      if (searchTerm.trim() !== '') {
        const filtered = boxlist.filter((item: any) => {
          console.log("searchTerm", searchTerm);
          console.log("item.boxName", item.name);
          return item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase());
        });
        setBoxlists(filtered);
      } else {
        setBoxlists(orgboxlist);
      }
    }
  };

  const ImageController = (fileBlob: any) => {
    if (fileBlob.target.id === "file") {
      const file = fileBlob.target.files[0];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const supportedExtensions = ["jpg", "jpeg", "png"];

      if (!supportedExtensions.includes(fileExtension)) {
        return confirmAlert({
          title: "확장자가 jpg, jpeg, png인 파일만 등록할 수 있습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      setUploadImage([...uploadImage, file]);
      if (imageSrc.length >= 10) {
        alert("이미지는 최대 10장까지 등록 가능합니다.");
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          setImageSrc([...imageSrc, reader.result]);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  //질병이미지
  const DiseaseImageUpload = (e: number) => {
    const OccurformData = new FormData();
    occurImage.map((item: any, idx: number) => {
      OccurformData.append("image", item, item.name);
    });
    axios
      .post(`/ifactory/api/file/uploadfile/pest/${e}`, OccurformData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        transformRequest: (formData) => formData,
      })
      .then((res) => {
        console.log("이미지업로드성공");
      })
      .catch((error) => {
        console.log("이미지업로드실패");
      });

    const DeathformData = new FormData();
    deathImage.map((item: any, idx: number) => {
      DeathformData.append("image", item, item.name);
    });
    axios
      .post(`/ifactory/api/file/uploadfile/pestSample/${e}`, DeathformData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        transformRequest: (formData) => formData,
      })
      .then((res) => {
        console.log("이미지업로드성공");
      })
      .catch((error) => {
        console.log("이미지업로드실패");
      });
  };
  //이미지 업로드
  const ImageUpload = (e: number) => {
    const formData = new FormData();
    uploadImage.map((item: any, idx: number) => {
      formData.append("image", item, item.name);
    });
    axios
      .post(`/ifactory/api/file/uploadfile/diary/${e}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        transformRequest: (formData) => formData,
      })
      .then((res) => {
        console.log("이미지업로드성공");
      })
      .catch((error) => {
        console.log("이미지업로드실패");
      });
  };
  // 미리보기 이미지 삭제
  const ImageRemove = (e: any) => {
    let idx;
    imageSrc.map((Image: any, idx: number) => {
      if (e === Image) {
        setImageSrc(imageSrc.filter((v: any, i: number) => i !== idx));
        setUploadImage(uploadImage.filter((v: any, i: number) => i !== idx));
      }
    });
  };

  // 일지 작성 버튼
  const PostSumit = async (data: any) => {
    console.log("post data:", data);
    const inputdiaryclassid = inputitem.diaryClasses.find(
      (v: DiaryClasstype) => v.diaryType === "DISEASE"
    );

    if (selectDate > new Date()) {
      return confirmAlert({
        title: "작성 시간이 현재 시간보다 앞설 수 없습니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }
    if (!diaryClassId || diaryClassId === 0) {
      setPostmodal(false);

      return confirmAlert({
        title: "작업을 선택해 주세요.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    let diaryid: any = []; // 이미지 등록할 다이어리 id
    let body = Object.keys(data).map((key) => {
      return {
        diaryItemId: data[key].diaryItemId,
        value: data[key].value,
      };
    });

    body.push(
      {
        diaryItemId: `${instartid}`,

        value: age,
      },
      {
        diaryItemId: `${productid}`,
        value: insectkind,
      }
    );

    // let pids = [Targetfarms?.placeId, mycontainer?.[0].placeId];
    let pids = placeId; //[Targetfarms?.placeId, mycontainer?.[0].placeId];

    const newPids = [pids];

    await axios
      .post(`/ifactory/api/diary`, {
        worker: me?.userId,
        diaryClassId: diaryClassId,
        placeIds: newPids,
        tagStdDate: `${startdate.startday} ${startdate.time}`,
        note: memo,
        diaryContents: body,
      })
      .then((res) => {
        diaryid.push(res.data);
        confirmAlert({
          title: "등록 되었습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        navigate("/MainPage", 
					{
						state: {
							isArrow: isArrow,
							id1: id1,
							id2: id2,
							id3: id3,
							id4: id4,
							id5: id5
						}
					});
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response.data);
        console.log("실패");
        setPostmodal(false);

        confirmAlert({
          title: `${error.response.data.message}`,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        setPostsubmit(true);
      });
    if (
      // 질병

      diaryClassId === inputdiaryclassid.diaryClassId
    ) {
      diaryid?.[0]?.map((item: number, idx: number) => {
        DiseaseImageUpload(item);
      });
    } else {
      diaryid?.[0]?.map((item: number, idx: number) => {
        ImageUpload(item);
      });
    }
  };

  useEffect(() => {
    const Fday = dayjs(new Date()).format("YYYY-MM-DD");

    const Stime = dayjs(new Date()).format("HH:mm");

    let data = {};

    data = { ...data, startday: Fday };
    data = { ...data, time: Stime };

    setStarDate(data);
  }, []);

  const plus = startdate.startday + " " + startdate.time;

  const selectDate = new Date(plus);

  const postfunc = (type: string) => {

    console.log("placeId 저장용:: ", selectedBoxPlaceId);

    if (type === "YES") {
      if (!diaryClassId || diaryClassId === 0) {
        setPostmodal(false);

        return confirmAlert({
          title: "작업을 선택해 주세요!",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }

      if (selectedBoxPlaceId.length < 1) {
        setPostmodal(false);

        return confirmAlert({
          title: "사육박스를 선택해 주세요.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      }
      switch (selectwork) {
        case 1:
          PostSumit(growing);
          break;
        case 2:
          PostSumit(feedchange);
          break;
        case 3:
          PostSumit(cleaning);
          break;
        case 4:
          PostSumit(feedGive);
          break;
        case 5:
          PostSumit(disease);
          break;
      }
    } else if (type === "NO") {
      setPostmodal(false);
    }
  };

  const now = dayjs(new Date()).format("YYYY년 MM월 DD일 dddd HH시 mm분");

  const GROWTHitems: DiaryClasstype = inputitem?.diaryClasses?.find(
    (v: DiaryClasstype) => v.diaryType === "GROWTH"
  );

  const REPLACEFEEDitems: DiaryClasstype = inputitem?.diaryClasses?.find(
    (v: DiaryClasstype) => v.diaryType === "REPLACEFEED"
  );

  const CLEANitems: DiaryClasstype = inputitem?.diaryClasses?.find(
    (v: DiaryClasstype) => v.diaryType === "CLEAN"
  );

  const FEEDitems: DiaryClasstype = inputitem?.diaryClasses?.find(
    (v: DiaryClasstype) => v.diaryType === "FEED"
  );

  const DISEASEitems: DiaryClasstype = inputitem?.diaryClasses?.find(
    (v: DiaryClasstype) => v.diaryType === "DISEASE"
  );

  const [boxmodal, setBoxmodal] = useState<boolean>(false);

  const modalClosefunc = useCallback(() => {

    const checkedDiary = diaryList.find((diary: TotaldataType) => diary.diaryId === checkedDiaryId);
    // console.log("checkItemCnt 사육일지 작성 alert 체크 :: ", checkItemCnt );
    const checkedCount = Object.values(checkedItems).filter(Boolean).length;

    setBoxmodal((prev) => !prev);

    // if(checkItemCnt  === 0) {
    //   if (window.confirm('사육일지 작성을 위한 BOX선택을 하지 않았습니다. \n이대로 종료 할까요?')) {
    //     console.log("checkedDiary:: ", checkedDiary);
    //     if(checkedDiary !== undefined) {
    //       setDiarytype(checkedDiary.diaryClass.diaryType);
    //       setProductCode(checkedDiary.diaryClass.productCode);
    //       setBoxmodal((prev) => !prev);
    //     } else {
    //       setBoxmodal((prev) => !prev);
    //     }
    //   } else {
    //     // Do nothing!
    //     console.log('stau');
    //   }
    // } else {
    //   if(checkedDiary !== undefined) {
    //     setDiarytype(checkedDiary.diaryClass.diaryType);
    //     setProductCode(checkedDiary.diaryClass.productCode);
    //     setBoxmodal((prev) => !prev);
    //   } else {
    //     setBoxmodal((prev) => !prev);
    //   }
    // }

    // console.log("checkedDiary11", checkedDiary.diaryClass.diaryType);
    // console.log("checkedDiary22", checkedDiary.diaryClass.productCode);

    // if(checkedDiary !== undefined) {

    //   setDiarytype(checkedDiary.diaryClass.diaryType);
    //   setProductCode(checkedDiary.diaryClass.productCode);

    //   // 생육단계 로딩
    //   const loadLifecycle = async () => {
    //     try {
    //       const response = await axios.get(
    //         `ifactory/api/diaryCode/classitem?productCode=${productCode}&diaryType=${diaryType}`
    //       );
    //       setInsectinstar(response.data);
    //       setAge(response.data[0].lifeCycle);

    //       console.log("setInsectinstar", response.data)

    //       //곤충 령기 아이템
    //     } catch (error) {
    //       console.error("error:", error);
    //     }
    //   };

    //   loadLifecycle();
    // }

  }, [checkedDiaryId, productCode, checkItems]);
  useEffect(() => {
    console.log("저장된 값 확인 :: ", productCode, diaryType);
    loadLifecycle();
  }, [productCode, diaryType]);

  const loadLifecycle = useCallback(async () => {
    if (!productCode || !diaryType) return;

    try {
      const response = await axios.get(
        `ifactory/api/diaryCode/classitem?productCode=${productCode}&diaryType=${diaryType}`
      );

      console.log("setInsectinstar :: ", response.data);

      // setInsectinstar(response.data.lifeCycleCode);
      // setAge(response.data[0].lifeCycle);


    } catch (error) {
      console.error("error:", error);
    }
  }, [productCode, diaryType]);


  const modalkeepfunc = useCallback(() => {
    setBoxmodal((prev) => !prev);
  }, []);

  return (
    <styles.Container>
      <styles.PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
              navigate(-1);
            }}
          />
        </p>
        <p className="pagetit">사육일지 작성</p>
        <button className="post-submit" onClick={() => setPostmodal(true)}>
          작성
        </button>
      </styles.PageTop>
      <styles.InfoData>
        <p className="Date"> 현재시간: {now}</p>

        {inputitem?.manageBox?.map((box: manageBoxType, idx: number) => {
          const startFarmDate = dayjs(box?.startFarmDate).format(
            "YYYY년 MM월 DD일"
          );

          const expFarmDate = dayjs(box?.expFarmDate).format(
            "YYYY년 MM월 DD일"
          );

          return (
            <styles.InfoBox>
              <styles.InfoItem>
                <p>곤충명</p>
                <p>
                  <span className="insect-name">
                    {InsectName(targetinsect)}
                  </span>
                </p>
              </styles.InfoItem>
              <styles.InfoItem>
                <p>사육시작</p>
                <p>{startFarmDate}</p>
              </styles.InfoItem>
              <styles.InfoItem>
                <p className="c-22c197">출하예정일</p>
                <p className="c-22c197">{expFarmDate}</p>
              </styles.InfoItem>
              <styles.InfoItem>
                {idx === 0 && (
                  <>
                    <p>작성자</p>
                    <p className="Spoqa700">{me?.userId}</p>
                  </>
                )}
              </styles.InfoItem>
            </styles.InfoBox>
          );
        })}
      </styles.InfoData>

      <styles.BreedingBox>
        <styles.BreedingBoxSelectedTop>
          <div
            style={{
              // display: "1",
              display: "flex",
              borderRadius: 10,
              backgroundColor: "#73972c",
              width: 100,
              height: 50,
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            <div
              style={{
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                cursor: "pointer",
              }}
              onClick={() => {
                setBoxmodal(true);
                setDiaryList([]); // diaryList 초기화
                setCheckItems([]); // checkItem 초기화
              }}
            >
              상자선택하기

            </div>
          </div>

          <styles.BreedingSelectedBoxBot style={{ justifyContent: 'flex-start', display: 'flex', marginLeft: '20px' }}>
            {selectedBoxes &&
							selectedBoxes.map((box: any, idx: any) => {
                let instarcolor = "";

                switch (box.instar) {
                  case "EGG":
                    instarcolor = "#feca0a";
                    break;
                  case "IMAGO":
                    instarcolor = "#b96730";
                    break;
                  case "PUPA":
                    instarcolor = "#afaad3";
                    break;
                  case "LARVA":
                    instarcolor = "#8bc63e";
                    break;
                  default:
                    instarcolor = "lightgray";
                }

                return (
                  <p
                    key={box.placeId}
                    className={
                      placeId.includes(box.placeId)
                        ? "breedingbox-active"
                        : "breedingbox"
                    }
                    style={{
                      background: placeId.includes(box.placeId)
                        ? "#2a3a4b"
                        : instarcolor,
                      height: 50,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 16,
                      color: "white",
                      whiteSpace: 'nowrap',
                      width: 'auto',
                    }}
                    onClick={() => {
                      // handleboxBtn(
                      //   box.name,
                      //   box.boxId,
                      //   idx,
                      //   box.productCode
                      // );
                    }}
                  >
                    {box.name}
                  </p>
                );
              })}
          </styles.BreedingSelectedBoxBot>

          <div>



            {/* <p>현재 선택된 상자 ID: {boxName.join(', ')}</p> */}
          </div>

        </styles.BreedingBoxSelectedTop>
      </styles.BreedingBox>

      {/* 환경정보 */}
      <Environment data={envData} />

      <styles.WorkSelector>
        <styles.InsectAge>
          <p className="content-tit">생육단계</p>
          <select onChange={SelectHandler} value={age}>
            {insectinstar &&
              insectinstar.map((item: any, idx: Number) => {
                return (
                  <option key={`key=${idx}`} value={item.lifeCycle}>
                    {InsectLifeCycle(item.lifeCycle)}
                  </option>
                );
              })}
          </select>
          <p className="content-tit">작업선택</p>
          <styles.WorkSelect>
            {inputitem?.diaryClasses &&
              inputitem?.diaryClasses.map((JobName: any, idx: Number) => {
                return (
                  <div
                    key={JobName.diaryClassId}
                    className={
                      selectwork === JobName.seq
                        ? "WorkSelect-list-active"
                        : "WorkSelect-list"
                    }
                    onClick={() => {
                      WorkSelector(JobName.diaryClassId, JobName.seq);
                    }}
                  >
                    <p className="WorkSelect-list-img">
                      <img src="./img/GrowthSurvey.svg" alt="asdasd" />
                    </p>
                    <p className="WorkSelect-list-text">{JobName.name}</p>
                  </div>
                );
              })}
          </styles.WorkSelect>
        </styles.InsectAge>




        <styles.WorkData>
          <div className="work-data-top">
            <p className="work-data-title">작업시간</p>
            <input
              type="date"
              name="startday"
              value={startdate.startday}
              onChange={InputHandler}
            />
            <input
              type="time"
              name="time"
              value={startdate.time}
              onChange={InputHandler}
            />
            <p className="work-data-arrow">
              <img
                src="./img/ArrowTop.svg"
                className={OpenWork === false ? "rotate" : ""}
                onClick={() => {
                  setOpenWork(!OpenWork);
                }}
              />
            </p>
          </div>

          {(() => {
            switch (selectwork) {
              case 1:
                return (
                  <PostDiaryForm.Growing
                    OpenWork={OpenWork}
                    inputitem={GROWTHitems?.diaryItems}
                    // inputitem={diaryitemss?.[0]?.diaryItems}
                    growing={growing}
                    setGrowing={setGrowing}
                    // DiaryClasstype={inputitem.diaryClasses[0].diaryType}
                    DiaryClasstype={GROWTHitems?.diaryType}
                  />
                );
              case 2:
                return (
                  <PostDiaryForm.FeedChange
                    OpenWork={OpenWork}
                    inputitem={REPLACEFEEDitems?.diaryItems}
                    feedchange={feedchange}
                    setFeedchange={setFeedchange}
                  />
                );
              case 3:
                return (
                  <PostDiaryForm.Cleaning
                    OpenWork={OpenWork}
                    inputitem={CLEANitems?.diaryItems}
                    cleaning={cleaning}
                    setCleaning={setCleaning}
                  />
                );
              case 4:
                return (
                  <PostDiaryForm.FeedGive
                    OpenWork={OpenWork}
                    inputitem={FEEDitems?.diaryItems}
                    feedGive={feedGive}
                    setFeedGive={setFeedGive}
                  />
                );
              case 5:
                return (
                  <PostDiaryForm.Disease
                    OpenWork={OpenWork}
                    inputitem={DISEASEitems?.diaryItems}
                    setDisease={setDisease}
                    disease={disease}
                    setOccurImage={setOccurImage}
                    setDeathImage={setDeathImage}
                    occurImage={occurImage}
                    deathImage={deathImage}
                  />
                );
              default:
                return;
            }
          })()}
        </styles.WorkData>
      </styles.WorkSelector>

      {/* 작업선택이 질병예찰일경우 다른 레이아웃 표출 */}
      {selectwork !== 5 ? (
        <styles.Memo>
          <p className="content-tit">사진</p>
          <styles.ImageUpload>
            <label htmlFor="file">
              <div className="camera-btn">
                <p className="camera-img">
                  <img src="./img/camera.svg" />
                </p>
                <p className="total-img">{ImageTotal}/10</p>
              </div>
            </label>
            <input
              type="file"
              id="file"
              accept="image/jpg, image/png, image/jpeg"
              onChange={(e: any) => ImageController(e)}
            />
            {imageSrc.map((Image: any, idx: any) => {
              return (
                <styles.PreviewIamge key={`index${idx}`}>
                  <p
                    onClick={() => {
                      ImageRemove(Image);
                    }}
                  >
                    <img src="./img/X.svg" />
                  </p>
                  <img src={Image} alt={idx} />
                </styles.PreviewIamge>
              );
            })}
          </styles.ImageUpload>
          <p className="content-tit mt-30">메모</p>
          <textarea name="memo" onChange={AreaHandler}></textarea>
        </styles.Memo>

      ) : (
        <styles.DiseaseBot>
          <styles.DiseaseMemo>
            <p>질병예찰검사 정보</p>
            <textarea name="memo" onChange={AreaHandler}></textarea>
          </styles.DiseaseMemo>
          <styles.DiseaseLink>
            <p>곤충 질병에 관해 궁금한 점은</p>
            <p>전문가에게 물어보세요</p>
            <button
              onClick={() => {
                navigate("/AdvicePage");
              }}
            >
              질병상담
            </button>
          </styles.DiseaseLink>
        </styles.DiseaseBot>
      )}

      <p style={{ fontSize: '1.2em', fontFamily: "spoqa700", textAlign: 'left', marginTop: '20px', marginLeft: '40px' }}>이전 작업 기록</p>
      <styles.DiaryDataRightBox style={{ width: 'calc(100% - 10px)', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', overflow: 'hidden', justifyContent: 'center' }}>
        {/* <div style={{ display: 'flex', flexDirection: 'row', overflowX: 'auto' }}> */}

        {beforeDiaryList?.map((item: any, idx: number) => (

          <div key={idx} style={{ marginRight: '30px', width: 'calc(33.33% - 30px)', height: '100%', border: '1px solid lightgray', padding: '10px', boxSizing: 'border-box' }}>
            <p className="right-box-date">{formatBeforeDate(item.tagStdDate)}</p>
            <button
              onClick={() => {
                setModal(1);
                handleBeforeDiaryList(beforeDiaryList, item.diaryId);
              }}
            >
              이전 환경정보 데이터
            </button>
            <p className="breeding-box-title">사육상자</p>

            <div className="breeding-box">
              {item.places.map((item: any, idx: number) => {
                if (item.type === "BOX") {
                  return <p className="breeding-item">{item.name}</p>;
                }
              })}
            </div>

            <div className="right-box-data">
              <p className="right-box-content">작업선택</p>
              <p className="right-box-value">
                {item?.diaryClass?.name}
              </p>
            </div>

            <p className="border-fff"></p>

            {item?.diaryContents.map((item: any, idx: number) => {
              if (item.diaryItem.view === "Y") {
                return (
                  <div className="right-box-data">
                    <p className="right-box-content">{item.diaryItem.note}</p>
                    <p className="right-box-value">{cleanDatecovert(item)}</p>
                  </div>
                );
              }
            })}
          </div>
        ))}

      </styles.DiaryDataRightBox>

      {postmodal && (
        <Modal
          title={"작성하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => postfunc("YES")}
          secondclick={() => postfunc("NO")}
        />
      )}

      {boxmodal ? (
        // <styles.Backdrop onClick={modalClosefunc}>
        //   <styles.ModalContainer onClick={modalkeepfunc}>
				<styles.Backdrop style={{ width:"100%",height:"100%" }}>
          <styles.ModalContainer style={{    minWidth:"unset",minHeight:"unset",width: "100%",height: "98%",maxWidth: "800px",maxHeight: "600px"}}>
            <styles.Modals style={{height:"100%",maxHeight:"700px",overflow:"auto"}}>
              {/* <div
                style={{
                  // backgroundColor: "lavender",
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <styles.BreedingPopBoxBot>
                  <p
                    className={"breedingbox-active"}
                    style={{
                      // marginLeft: 10,
                      background: "#feca0a",
                      color: "white",
                      // width: 30,
                      textAlign: "center",
                    }}
                  >알</p>
                </styles.BreedingPopBoxBot>

                <styles.BreedingPopBoxBot>
                  <p
                    className={"breedingbox-active"}
                    style={{
                      // marginLeft: 10,
                      background: "#8bc63e",
                      color: "white",
                      // width: 30,
                      textAlign: "center",
                    }}
                  >유충</p>
                </styles.BreedingPopBoxBot>

                <styles.BreedingPopBoxBot>
                  <p
                    className={"breedingbox-active"}
                    style={{
                      marginLeft: 10,
                      background: "#afaad3",
                      color: "white",
                      // width: 30,

                      textAlign: "center",
                    }}
                  >성충</p>
                </styles.BreedingPopBoxBot>

                <styles.BreedingPopBoxBot>
                  <p
                    className={"breedingbox-active"}
                    style={{
                      marginLeft: 10,
                      background: "#b96730",
                      color: "white",
                      // width: 30,
                      textAlign: "center",
                    }}
                  >번데기</p>
                </styles.BreedingPopBoxBot>
              </div> */}

              <SearchBox>
                <SearchInput type="text" placeholder="상자 이름 검색"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onKeyPress={handleKeyPress}
                />
                <SearchButton onClick={handleClick}>검색</SearchButton>
              </SearchBox>

              <styles.BreedingPopBoxBot style={{height:"calc(100% - 135px)",minHeight:"180px"}}>
                {boxlist && (

                  <div style={{ display: 'flex', justifyContent: 'space-between', maxHeight: '500px', overflowY: 'auto',minHeight:"150px",height:"100%" }}>
										<div style={{ display: 'flex', maxHeight: '500px', overflowY: 'auto', alignSelf: 'flex-start', minWidth:"170px",minHeight:"150px",height:"100%" }}>
                      <table style={{ width: '150px', borderCollapse: 'collapse', border: 'none',display:"inline-block" }}>
                        <tbody>

                          {boxlist.map((box: any, idx: any) => {
                            let instarcolor = '';
                            // console.log(box);
                            switch (box.instar) {
                              // case 'EGG':
                              //   instarcolor = '#feca0a';
                              //   break;
                              // case 'IMAGO':
                              //   instarcolor = '#b96730';
                              //   break;
                              // case 'PUPA':
                              //   instarcolor = '#afaad3';
                              //   break;
                              // case 'LARVA':
                              //   instarcolor = '#8bc63e';
                              //   break;
                              default:
																//instarcolor = 'lightgray';
																instarcolor = '#2a3a4b';
															
                            }

                            return (
                              <tr
                                style={{
                                  height: '35px', // 추가
                                }}
                              >
                                <td
                                  className={
                                    placeId.includes(box.boxName)
                                      ? 'breedingbox-active'
                                      : 'breedingbox'
                                  }
                                  style={{
                                    background: placeId.includes(box.placeId)
																			//? '#2a3a4b'
																			? '#73972c'
                                      : instarcolor,
                                    width: '130px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: 12,
                                    color: 'white',
                                    padding: '5px',
                                    marginLeft: '0px',
                                    marginRight: '0px',
                                    marginBottom: '10px',
                                  }}
                                  onClick={() => {
                                    handleboxBtn(box.name, box.placeId, idx, box.instar);
                                  }}
                                >
                                  {box.name}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>


                    <div style={{ maxHeight:"500px",height: '100%',/*height: '500px', */overflow: 'auto', paddingLeft: '0px', overflowY: 'auto' }}>
                      <Styledtable>
                        <thead>
                          <tr>
                            <StyledTh>상자이름</StyledTh>
                            <StyledTh>곤충명</StyledTh>
                            <StyledTh>생육상태</StyledTh>
                            <StyledTh>작업상태</StyledTh>
                            <StyledTh>사육시작일</StyledTh>
                            <StyledTh>출하예정일</StyledTh>
                            <StyledTh>출하일</StyledTh>
                          </tr>
                        </thead>
                        <tbody>
                          {diaryList.map((diary: TotaldataType, index: any) => (
                            <tr key={diary.diaryId}>
                              {/* <td style={{textAlign: 'center', border: '1px solid #eee' }}>
                          <input type="checkbox"
                            checked={checkItems.includes(diary.diaryId)}
                            // checked={checkedItems[diary.diaryId] || false}
                            name="checkItem"
                            onChange={(e) => {
                              
                              console.log("0). latest checkItemCnt :: ", latestCheckItems);

                              let countingCheck;
                              if (e.target.checked) {
                                countingCheck = [...checkItems, diary.diaryId];
                              } else {
                                countingCheck = checkItems.filter(el => el !== diary.diaryId);
                              }
                              setLatestCheckItems(countingCheck);
                              
                              console.log("0.1). latest countingCheck :: ", countingCheck);
                              console.log("0.2). latest checkItemCnt :: ", latestCheckItems);

                              if (countingCheck.length > 1 ) {
                                alert('이미 다른 항목이 체크되어 있습니다. 하나만 선택해주세요.');
                                setCheckedItems(prev => ({ ...prev, [diary.diaryId]: false })); // 체크 상태 해제
                              } else {
                                setCheckedItems(prev => ({ ...prev, [diary.diaryId]: e.target.checked })); // 체크 상태 설정
                                handleSingleCheck((e.target as HTMLInputElement).checked, diary.diaryId, e);

                              }
                              
                             
                              // handleSingleCheck((e.target as HTMLInputElement).checked, diary.diaryId, e)}
                            }}
                            onClick={(e) => {

                             
                              // console.log("e.target.checked :: ", (e.target as HTMLInputElement).checked);
                              // console.log("1). onclick checkItemCnt :: ", checkItemCnt);
                              // console.log("=======================================================");
                             
                            }}
                          />
                        </td> */}
                              <StyledTd>{diary.boxName}</StyledTd>
                              <StyledTd>{InsectName(diary.diaryClass.productCode)}</StyledTd>
                              <StyledTd>{InsectLifeCycle(diary.instar)}</StyledTd>
                              <StyledTd>{diary.diaryClass.diaryType}</StyledTd>
                              <StyledTd>{new Date(diary.startFarmDate).toLocaleString()}</StyledTd>
                              <StyledTd>{new Date(diary.expFarmDate).toLocaleString()}</StyledTd>
                              <StyledTd>{new Date(diary.tagStdDate).toLocaleString()}</StyledTd>
                            </tr>
                          ))}


                        </tbody>
                      </Styledtable>
                    </div>
                  </div>


                )}
              </styles.BreedingPopBoxBot>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: 80,
              }}
            >
              <div
                style={{
                  display: "flex",
                  background: "#73972c",
                  width: 80,
                  height: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 10,
                  color: "white",
                }}
                onClick={modalClosefunc}
              >
                확인
              </div>
            </div>
            </styles.Modals>
          </styles.ModalContainer>
        </styles.Backdrop>
      ) : null}

      {/* 이전 데이터 컴포넌트 */}
      {modal === 1 ? <BeforeData modal={modal}
        filteredDiaryList={filteredDiaryList}
        setModal={setModal} /> : null}

    </styles.Container>
  );
};

export default PostDiaryPage;
